// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"db8100ce","389":"b5496a65"}[chunkId] + ".chunk.css";
};